// Lightweight IPv4 / IPv6 validators used by smart-notification tag inputs.
// Pure string predicates — no dependencies on Vue / component state.

export function isValidIpv4(s) {
  const parts = s.split('.');

  if (parts.length !== 4) {
    return false;
  }

  return parts.every((p) => {
    if (!/^\d{1,3}$/.test(p)) {
      return false;
    }

    // No leading zeros (e.g. '01' is invalid)
    if (p.length > 1 && p[0] === '0') {
      return false;
    }

    return Number(p) <= 255;
  });
}

export function isValidIpv6(input) {
  let s = input;

  // Strip and validate an embedded IPv4 suffix (e.g. '::ffff:192.168.1.1')
  if (s.includes('.')) {
    const lastColon = s.lastIndexOf(':');

    if (lastColon < 0) {
      return false;
    }

    const v4 = s.slice(lastColon + 1);

    if (!isValidIpv4(v4)) {
      return false;
    }

    // Replace the v4 tail with two hex-group placeholders for structural validation
    s = `${s.slice(0, lastColon + 1)}0:0`;
  }

  const halves = s.split('::');

  if (halves.length > 2) {
    return false;
  }

  const isHexGroup = (g) => /^[\da-fA-F]{1,4}$/.test(g);
  const splitGroups = (g) => (g === '' ? [] : g.split(':'));
  const left = splitGroups(halves[0]);
  const right = halves.length === 2 ? splitGroups(halves[1]) : null;

  if (right === null) {
    // No '::' compression — must have exactly 8 hex groups
    return left.length === 8 && left.every(isHexGroup);
  }

  // With compression, the explicit groups must total fewer than 8
  // (the '::' stands in for at least one all-zero group)
  if (left.length + right.length >= 8) {
    return false;
  }

  return left.every(isHexGroup) && right.every(isHexGroup);
}

export function isValidIp(term) {
  return isValidIpv4(term) || isValidIpv6(term);
}
